import ButtonNotFound from '@/components/sections/builder/elements/body/not-found/button';
import NotFoundElementContent from '@/components/sections/builder/elements/body/not-found/content';
import HeadingNotFound from '@/components/sections/builder/elements/body/not-found/heading';

import NotFoundElementSetting from '@/components/sections/builder/elements/body/not-found/setting';
import TextNotFound from '@/components/sections/builder/elements/body/not-found/text';
import { NotFoundElementDataType } from '@/components/sections/builder/elements/body/not-found/type';
import { DEFAULT_THEME_COLOR_SCHEME } from '@/components/sections/builder/theme/color';
import { LayoutIcon } from 'lucide-react';

export const defaultData: NotFoundElementDataType = {
  name: 'Not Found',
  alignment: 'center',
  colorScheme: DEFAULT_THEME_COLOR_SCHEME,
  overlayOpacity: 100,
};

export const ElementPreviewIcon = LayoutIcon;

const NotFound = {
  type: 'not_found',
  group: 'body_not_found',
  defaultData,
  Element: NotFoundElementContent,
  Setting: NotFoundElementSetting,
  PreviewIcon: ElementPreviewIcon,
  defaultChilds: [HeadingNotFound, TextNotFound, ButtonNotFound],
  childs: [HeadingNotFound, TextNotFound, ButtonNotFound],
  maxEntries: 1,
  isImmutable: true,
};

export default NotFound;
